import styled from "styled-components/native";
import { margin } from "styled-system";
import SVG from "react-native-svg";

export const StyledSVG = styled(SVG)(margin);
